/* Light friction against casual image saving.

   Read this before trusting it: none of this stops a determined person, and
   it is not meant to. Anyone can open devtools, view source, or request the
   image URL directly, and no web page can prevent a screenshot — that is an
   operating-system function, not a browser one. Any script or app claiming
   otherwise is lying.

   What actually protects the artwork is elsewhere:
     - the watermark burned into every image the site serves
     - the served image being 1000px tall, far too small to print at A4
     - the clean master never being uploaded at all

   This file only removes the two easiest paths — right-click "Save image as"
   and dragging the picture to the desktop — so a casual visitor does not walk
   off with a copy without meaning to. Treat it as a doorbell, not a lock. */

(function () {
  'use strict';

  var SELECTOR = [
    '.frame-card__media img',
    '.card__media img',
    '.gift-preview__base',
    '.frame-reader__panel img'
  ].join(',');

  function guard(e) {
    if (e.target.tagName === 'IMG' && e.target.matches(SELECTOR)) {
      e.preventDefault();
    }
  }

  document.addEventListener('contextmenu', guard);
  document.addEventListener('dragstart', guard);
})();
